import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const files: any = require.context('./modules', false, /\.ts$/);
const modules: any = {};

files.keys().forEach((key: string) => {
  modules[key.replace(/(\.\/|\.ts)/g, '')] = files(key).default;
});

export default new Vuex.Store({
  modules,
});
